"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _clientAwsS = require("@devsta/client-aws-s3");

var _moment = _interopRequireDefault(require("moment"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _commonReact = require("@devsta/common-react");

require("./_create-campaign-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INITIAL_STATE = function INITIAL_STATE() {
  var campaign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    inspirationCampaignId: campaign.inspirationCampaignId || null,
    name: campaign.name || '',
    description: campaign.description || '',
    coverPhoto: campaign.coverImageKey ? {
      preview: {
        url: campaign.coverImageKey
      }
    } : void 0,
    tags: campaign.tags,
    startDate: campaign.startDate ? (0, _moment.default)(campaign.startDate.toString(), 'x') : void 0,
    endDate: campaign.endDate ? (0, _moment.default)(campaign.endDate.toString(), 'x') : void 0,
    key: Date.now(),
    permissions: campaign.permissions || []
  };
};

function valid(_ref) {
  var name = _ref.name;
  return Boolean(name);
}

var UpdateCampaignModal = /*#__PURE__*/function (_Component) {
  _inherits(UpdateCampaignModal, _Component);

  function UpdateCampaignModal(props) {
    var _this;

    _classCallCheck(this, UpdateCampaignModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UpdateCampaignModal).call(this, props)); // $FlowFixMe

    _defineProperty(_assertThisInitialized(_this), "resetState", function (_ref2) {
      var _ref2$campaign = _ref2.campaign,
          campaign = _ref2$campaign === void 0 ? {} : _ref2$campaign;

      _this.setState(INITIAL_STATE(campaign));
    });

    _defineProperty(_assertThisInitialized(_this), "addCustomPhotoToCampaign", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(campaign) {
        var _this$props, apiClient, updateCampaign, coverPhoto, organisationId, inspirationCampaignId, coverImageKey, bucketKey, _ref4, data, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, apiClient = _this$props.apiClient, updateCampaign = _this$props.updateCampaign;
                coverPhoto = _this.state.coverPhoto;
                organisationId = campaign.organisationId, inspirationCampaignId = campaign.inspirationCampaignId, coverImageKey = campaign.coverImageKey; // $FlowFixMe

                if (coverPhoto) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", campaign);

              case 5:
                bucketKey = "organisation/".concat(organisationId, "/inspiration-campaign/").concat(inspirationCampaignId, "/coverphoto");
                _context.prev = 6;
                _context.next = 9;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apiClient,
                  file: coverPhoto,
                  bucketKey: bucketKey,
                  organisationId: organisationId
                });

              case 9:
                if (!coverImageKey) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", campaign);

              case 11:
                _context.next = 13;
                return updateCampaign({
                  inspirationCampaignId: inspirationCampaignId,
                  input: {
                    coverImageKey: bucketKey
                  }
                });

              case 13:
                _ref4 = _context.sent;
                data = _ref4.data;
                error = _ref4.error;
                return _context.abrupt("return", !error && data && data.updateCampaign ? data.updateCampaign : null);

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](6);
                (0, _commonReact.notify)({
                  content: 'Something went wrong. Please try again.',
                  type: 'error'
                });
                return _context.abrupt("return", null);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 19]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleCreateOrUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, updateCampaign, createCampaign, hideModal, onCampaignUpdated, apiClient, _this$state, inspirationCampaignId, coverPhoto, imageUploaded, key, permissions, campaign, _ref6, data, error, returnedCampaign, campaignWithPhoto, withCoverImage;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, updateCampaign = _this$props2.updateCampaign, createCampaign = _this$props2.createCampaign, hideModal = _this$props2.hideModal, onCampaignUpdated = _this$props2.onCampaignUpdated, apiClient = _this$props2.apiClient;
              _this$state = _this.state, inspirationCampaignId = _this$state.inspirationCampaignId, coverPhoto = _this$state.coverPhoto, imageUploaded = _this$state.imageUploaded, key = _this$state.key, permissions = _this$state.permissions, campaign = _objectWithoutProperties(_this$state, ["inspirationCampaignId", "coverPhoto", "imageUploaded", "key", "permissions"]);

              if (!inspirationCampaignId) {
                _context2.next = 8;
                break;
              }

              _context2.next = 5;
              return updateCampaign({
                inspirationCampaignId: inspirationCampaignId,
                input: campaign
              });

            case 5:
              _context2.t0 = _context2.sent;
              _context2.next = 11;
              break;

            case 8:
              _context2.next = 10;
              return createCampaign(campaign);

            case 10:
              _context2.t0 = _context2.sent;

            case 11:
              _ref6 = _context2.t0;
              data = _ref6.data;
              error = _ref6.error;

              if (!(!data || error)) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("return");

            case 16:
              returnedCampaign = inspirationCampaignId ? data.updateCampaign : data.createCampaign;

              if (returnedCampaign) {
                _context2.next = 19;
                break;
              }

              return _context2.abrupt("return");

            case 19:
              if (!imageUploaded) {
                _context2.next = 25;
                break;
              }

              _context2.next = 22;
              return _this.addCustomPhotoToCampaign(returnedCampaign);

            case 22:
              _context2.t1 = _context2.sent;
              _context2.next = 26;
              break;

            case 25:
              _context2.t1 = returnedCampaign;

            case 26:
              campaignWithPhoto = _context2.t1;

              if (campaignWithPhoto) {
                _context2.next = 29;
                break;
              }

              return _context2.abrupt("return");

            case 29:
              _this.setState({
                imageUploaded: false
              });

              _context2.prev = 30;

              if (!campaignWithPhoto.coverImageKey) {
                _context2.next = 37;
                break;
              }

              _context2.next = 34;
              return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                apiClient: apiClient,
                data: campaignWithPhoto,
                substitutedKeys: ['coverImageKey']
              });

            case 34:
              _context2.t2 = _context2.sent;
              _context2.next = 38;
              break;

            case 37:
              _context2.t2 = campaignWithPhoto;

            case 38:
              withCoverImage = _context2.t2;
              onCampaignUpdated(withCoverImage);
              _context2.next = 45;
              break;

            case 42:
              _context2.prev = 42;
              _context2.t3 = _context2["catch"](30);
              onCampaignUpdated(campaignWithPhoto);

            case 45:
              hideModal();

            case 46:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[30, 42]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSelectCoverPhoto", function (files) {
      if (!files || !files.length) {
        return;
      }

      _this.setState({
        coverPhoto: files[0],
        imageUploaded: true
      });

      _this._filesRef.removeFiles();
    });

    _defineProperty(_assertThisInitialized(_this), "setFilesRef", function (ref) {
      _this._filesRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateField", function (key) {
      return function (value) {
        _this.setState(_defineProperty({}, key, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(value)));
      };
    });

    _this.state = INITIAL_STATE(props.campaign);
    return _this;
  }

  _createClass(UpdateCampaignModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          campaign = _this$props3.campaign,
          visible = _this$props3.visible;

      if (!visible && prevProps.visible || prevProps.campaign !== campaign) {
        this.resetState(this.props);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          visible = _this$props4.visible,
          hideModal = _this$props4.hideModal,
          campaign = _this$props4.campaign;
      var _this$state2 = this.state,
          coverPhoto = _this$state2.coverPhoto,
          name = _this$state2.name,
          description = _this$state2.description,
          tags = _this$state2.tags,
          key = _this$state2.key;
      return _react.default.createElement("div", {
        className: "create-campaign-modal"
      }, _react.default.createElement(_uiKit.FormModal, {
        key: "create-campaign-modal",
        visible: visible,
        onClose: hideModal,
        title: !campaign ? 'Create New Campaign' : 'Manage Details',
        onSave: this.handleCreateOrUpdate,
        saveText: "SAVE & CONTINUE",
        saveDisabled: !valid(this.state),
        stayOpenOnSave: true
      }, _react.default.createElement("div", {
        className: "create-campaign-modal__content"
      }, _react.default.createElement("p", null, "Cover Photo"), _react.default.createElement("div", {
        className: "create-campaign-modal__content__section"
      }, _react.default.createElement(_reactFiles.default, {
        ref: this.setFilesRef,
        className: "create-campaign-modal__content__drop",
        dropActiveClassName: "create-campaign-modal__content__drop--active",
        onChange: this.handleSelectCoverPhoto,
        clickable: true,
        multiple: false,
        accepts: ['image/*', '*svg*']
      }, coverPhoto ? _react.default.createElement(_uiKit.Image, {
        imageUrl: coverPhoto.preview.url,
        height: "100%",
        width: "100%"
      }) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("p", null, "Upload Cover Photo"), _react.default.createElement("p", {
        className: "create-campaign-modal__content__drop__text"
      }, "Drag & drop your file or", ' ', _react.default.createElement("span", null, "browse")), _react.default.createElement("p", null, "Recommended image size: 1920x350px"))), coverPhoto ? _react.default.createElement("div", {
        className: "create-campaign-modal__content__drop-footer"
      }, _react.default.createElement("p", null, coverPhoto.name), _react.default.createElement(_uiKit.Button, {
        onClick: this._filesRef && this._filesRef.openFileChooser,
        small: true
      }, "UPLOAD PHOTO")) : null), _react.default.createElement("p", {
        className: "create-campaign-modal__content__details-title"
      }, "Basic Details"), _react.default.createElement("div", {
        className: "create-campaign-modal__content__section create-campaign-modal__content__basic"
      }, _react.default.createElement(_uiKit.Input, {
        label: "CAMPAIGN NAME*",
        placeholder: "Enter name",
        onChange: this.onUpdateField('name'),
        defaultValue: name,
        key: "".concat(key, "-name")
      }), _react.default.createElement(_uiKit.Input, {
        label: "DESCRIPTION",
        placeholder: "Enter description",
        onChange: this.onUpdateField('description'),
        multiline: true,
        rows: 3,
        defaultValue: description,
        key: "".concat(key, "-desc")
      }), _react.default.createElement(_uiKit.TagInput, {
        label: "TAGS",
        placeholder: "Add tags",
        onChange: this.onUpdateField('tags'),
        defaultValue: tags,
        key: "".concat(key, "-tags")
      })))));
    }
  }]);

  return UpdateCampaignModal;
}(_react.Component);

exports.default = UpdateCampaignModal;